import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {benchmarkPercentileSeriesName} from '../../../../shared/helpers';
import {MetricType} from '../../../../shared/metric-types';
import {BenchmarkHelperObject, BenchmarkType} from '../../../../shared/benchmark-types';
import {BenchmarkTypesForNpv, BenchmarkTypesForWrvu} from '../../../../shared/BenchmarkColumns';
import {determineBenchmarkOptions} from '../../mpe-dialog-helper';
import {BenchmarkOption} from '../../../../shared/enums';
import {BatchExportMetricSection} from '../../../batch-export-helper';

@Component({
  selector: 'app-batch-export-benchmark-selector',
  templateUrl: './batch-export-benchmark-selector.component.html',
  styleUrls: ['./batch-export-benchmark-selector.component.scss']
})
export class BatchExportBenchmarkSelectorComponent implements OnChanges {

  @Input() batchExportMetricSection: BatchExportMetricSection;
  @Input() selected = false;
  @Output() whenBenchmarkOptionChosen = new EventEmitter<BenchmarkOption>();
  @Output() whenPercentileChosen = new EventEmitter<BenchmarkType>();
  benchmarkOptions: BenchmarkHelperObject[] = [];
  percentiles: SelectablePercentile[] = [];
  private readonly defaultPercentile = BenchmarkType.Mean;
  readonly defaultPercentileName = benchmarkPercentileSeriesName(this.defaultPercentile);
  readonly benchmarkPercentileSeriesName = benchmarkPercentileSeriesName;

  constructor() { }

  ngOnChanges(): void {
    this.benchmarkOptions = determineBenchmarkOptions(this.batchExportMetricSection ?
      this.batchExportMetricSection.metric : MetricType.None);
    this.determinePercentiles();
  }

  private determinePercentiles(): void {
    switch (this.batchExportMetricSection ? this.batchExportMetricSection.metric : MetricType.None) {
      case MetricType.WorkRVUs:
      case MetricType.OverviewWrvu:
        this.percentiles = BenchmarkTypesForWrvu.map(benchmark => {
          return {
            percentile: benchmark, text: benchmarkPercentileSeriesName(benchmark)
          };
        });
        break;
      case MetricType.NewPatientVisits:
      case MetricType.OverviewNpv:
        this.percentiles = BenchmarkTypesForNpv.map(benchmark => {
          return {
            percentile: benchmark, text: benchmarkPercentileSeriesName(benchmark)
          };
        });
        break;
      default:
        this.percentiles = [];
    }
  }

  chooseBenchmarkOption(benchmarkOption: BenchmarkOption): void {
    this.whenBenchmarkOptionChosen.emit(benchmarkOption);
  }

  choosePercentile(percentile: BenchmarkType): void {
    this.whenPercentileChosen.emit(percentile);
  }
}

interface SelectablePercentile {
  percentile: BenchmarkType;
  text: string;
}
